import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    sso_auth: false,
    session_timer: null,
    has_authenticated: false,
    last_activity: null,
    session_timeout_id: null,
    mpin: null,
    mpin_setup: false,
    microsoft_setup: false,
  },
  reducers: {
    setIsSSO: (state, action) => {
      state.sso_auth = action.payload;
    },
    
    setAuthenticated: (state, action) => {
      state.has_authenticated = action.payload;
      if (action.payload) {
        state.session_timer = Date.now() + (import.meta.env.VITE_APP_SESSION * 60 * 1000);
        state.last_activity = Date.now();
      } else {
        state.session_timer = null;
        state.last_activity = null;
      }
    },
    
    updateLastActivity: (state) => {
      state.last_activity = Date.now();
      state.session_timer = Date.now() + (import.meta.env.VITE_APP_SESSION * 60 * 1000);
    },
    
    setSessionTimeoutId: (state, action) => {
      state.session_timeout_id = action.payload;
    },
    
    setMpin: (state, action) => {
      state.mpin = action.payload;
      state.mpin_setup = true;
    },
    
    clearMpin: (state) => {
      state.mpin = null;
      state.mpin_setup = false;
    },
    
    setMicrosoftSetup: (state, action) => {
      state.microsoft_setup = action.payload;
    },
    
    clearSession: (state) => {
      state.has_authenticated = false;
      state.session_timer = null;
      state.last_activity = null;
      state.session_timeout_id = null;
      state.sso_auth = false;
      // Keep MPIN and setup states during session clear
    },
    
    clearAllAuth: (state) => {
      state.has_authenticated = false;
      state.session_timer = null;
      state.last_activity = null;
      state.session_timeout_id = null;
      state.sso_auth = false;
      state.mpin = null;
      state.mpin_setup = false;
      state.microsoft_setup = false;
    },
    
    checkSessionExpiry: (state) => {
      if (state.session_timer && Date.now() > state.session_timer) {
        // Session expired
        state.has_authenticated = false;
        state.session_timer = null;
        state.last_activity = null;
        state.session_timeout_id = null;
        state.sso_auth = false;
      }
    }
  },
});

export const {
  setIsSSO,
  setAuthenticated,
  updateLastActivity,
  setSessionTimeoutId,
  setMpin,
  clearMpin,
  setMicrosoftSetup,
  clearSession,
  clearAllAuth,
  checkSessionExpiry
} = authSlice.actions;

export default authSlice.reducer;